import { ToastNotificationContainer } from '@components/cockpit/toast/notification/ToastNotificationContainer';
import { CommonMapLayers } from '@components/map/layers/CommonMapLayers';
import { DrawPolygonLayer } from '@components/map/layers/draw/polygons/DrawPolygonLayer';
import FlightPlanLayer from '@components/map/layers/flightPlans/operational/FlightPlanLayer';
import { PlatformLayer } from '@components/map/layers/platforms/PlatformLayer';
import SelectionLayer from '@components/map/layers/SelectionLayer';
import ZoneLayer from '@components/map/layers/zones/ZoneLayer';
import MapboxMap from '@components/map/MapboxMap';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectMapDrawModeByMapId } from '@redux/maps/maps.selectors';

import EngagementLayer from './layers/engagement/EngagementLayer';

export function LADMap() {
  const isMapDrawModeOn = useSelectorWithMapId(selectMapDrawModeByMapId);
  // Do not add controls here
  return (
    <MapboxMap>
      <PlatformLayer />
      {isMapDrawModeOn && <DrawPolygonLayer />}
      <ZoneLayer />
      <FlightPlanLayer />
      <CommonMapLayers />
      <EngagementLayer />
      <SelectionLayer />
      <ToastNotificationContainer />
    </MapboxMap>
  );
}
